import type { ConnectionPositionPair } from '@angular/cdk/overlay';
import type { OnChanges, SimpleChanges } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
  output,
  inject,
  input,
} from '@angular/core';

import { AnalyticsMode } from '@core/analytics-types';
import { ShareCandidatesWithContextAnalytics } from '@core/candidate-util';
import { TranslatePipe } from '@core/i18n-legacy';
import {
  BadgeComponent,
  ButtonComponent,
  ConnectedOverlayDirective,
  IconComponent,
  OverlayOriginDirective,
  RtTooltip,
} from '@core/user-interface-legacy';

import { CandidateSharingDropdownComponent } from '../candidate-sharing-dropdown/candidate-sharing-dropdown.component';

@Component({
  selector: 'rt-sharing-button',
  imports: [
    ButtonComponent,
    IconComponent,
    TranslatePipe,
    ConnectedOverlayDirective,
    OverlayOriginDirective,
    CandidateSharingDropdownComponent,
    RtTooltip,
    BadgeComponent,
  ],
  templateUrl: './sharing-button.component.html',
  styleUrls: ['./sharing-button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ShareCandidatesWithContextAnalytics],
})
export class SharingButtonComponent implements OnChanges {
  private readonly shareCandidatesWithContextAnalytics = inject(
    ShareCandidatesWithContextAnalytics,
  );

  public readonly candidateId = input<number>(undefined!);
  @Input() public sharedAdminCount: number = 0;
  @Input() public sharedContainerCount: number = 0;

  public newItemClick = output<void>();

  @ViewChild('sharingDropdownComponent')
  public sharingDropdownComponent!: CandidateSharingDropdownComponent;

  public dropdownPositions: ConnectionPositionPair[] = [
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
  ];

  public showShareSum = false;

  @ViewChild('sharingDropdown', { read: ConnectedOverlayDirective })
  private sharingDropdown!: ConnectedOverlayDirective;

  public ngOnChanges(changes: SimpleChanges) {
    if ('sharedAdminCount' in changes || 'sharedContainerCount' in changes) {
      this.showShareSum = this.sharedAdminCount + this.sharedContainerCount > 0;
    }
  }

  public closeSharingDropdown(): void {
    this.sharingDropdown.backdropClick.next();
  }

  public onShareClick(): void {
    this.sharingDropdown.open = !this.sharingDropdown.open;
    this.shareCandidatesWithContextAnalytics.trackClickShare(AnalyticsMode.Single);
  }
}
